import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquare, faCheckSquare, faCircle, faDotCircle } from '@fortawesome/free-regular-svg-icons'

export const fetchFontAwesomeFacetIcon = (type, checked) => {
  if (type === 'checkbox' && !checked) {
    return <FontAwesomeIcon icon={faSquare} />
  } else if (type === 'checkbox' && checked) {
    return <FontAwesomeIcon icon={faCheckSquare} />
  } else if (type === 'radio' && !checked) {
    return <FontAwesomeIcon icon={faCircle} />
  } else {
    return <FontAwesomeIcon icon={faDotCircle} />
  }
}
